<app-layout preset="data">
  <app-layout-title></app-layout-title>

  <app-layout-actions>
    <app-order-actions [filter]="filter"
                       [backLink]="['history/statuses', changeGroupId, statusChangeId]"
                       [orderCount]="orderCount">
    </app-order-actions>

    <app-column-select #col [columns]="columns"></app-column-select>
  </app-layout-actions>

  <app-layout-content>
    <app-table #table
               (selectionChanged)="onSelectionChanged($event)"
               (totalCountChanged)="onTotalCountChanged($event)"
               [columns]="col.activeColumns"
               [dataSource]="dataSource"
               [reloader]="reloader"
               [withSelection]="true"
               loadingType="paginated">

      <ng-container *app-table-header="'id'">ID</ng-container>

      <ng-container *app-table-header="'cart'">{{ 'UNLOADED_ORDERS.TABLE.cart' | translate }}</ng-container>

      <ng-container *app-table-header="'recipient'">{{ 'UNLOADED_ORDERS.TABLE.recipient' | translate }}</ng-container>

      <ng-container *app-table-header="'status'">{{ 'UNLOADED_ORDERS.TABLE.status' | translate }}</ng-container>

      <ng-container *app-table-header="'dates'">{{ 'UNLOADED_ORDERS.TABLE.dates' | translate }}</ng-container>

      <ng-container *app-table-header="'tracking'">{{ 'UNLOADED_ORDERS.TABLE.track' | translate }}</ng-container>

      <ng-container *app-table-header="'additions'">{{ 'UNLOADED_ORDERS.TABLE.additions' | translate }}</ng-container>

      <ng-container *app-table-header="'store'">{{ 'UNLOADED_ORDERS.TABLE.store' | translate }}</ng-container>

      <ng-container *app-table-header="'comment'">{{ 'UNLOADED_ORDERS.TABLE.comment' | translate }}</ng-container>

      <ng-container *app-table-header="'courier'">{{ 'UNLOADED_ORDERS.TABLE.courier' | translate }}</ng-container>

      <app-order-columns-container [columns]="columnNames"
                                   [tableLoading]="table.loading">
      </app-order-columns-container>

    </app-table>
  </app-layout-content>
</app-layout>
